import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { OverdueFilters } from 'components/statistics/overdue-filters';
import { OverdueTabs } from 'components/statistics/overdue-tabs';

const OverduePageComponent = () => {
  const header = <PageHeader title={<OverdueFilters />} />;

  return (
    <DefaultPageLayout header={header}>
      <OverdueTabs />
    </DefaultPageLayout>
  );
};

export const OverduePage = withRoleGuard(OverduePageComponent, [UserRole.admin]);
